import { InfoTitle } from '@mi-front/ui';
import ShareIcon from '@mui/icons-material/Share';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

export interface SocialExportPublishSectionHeaderProps {
  /** Section title (already translated). */
  title: ReactNode;
  /** Optional trailing controls (e.g. publish dropdown). */
  actions?: ReactNode;
}

/**
 * Header row for the social publish block: icon + title + optional actions (used by fragment + compose views).
 */
export function SocialExportPublishSectionHeader({
  title,
  actions,
}: SocialExportPublishSectionHeaderProps) {
  return (
    <Box
      mb={2}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 3,
      }}
    >
      <InfoTitle>
        <ShareIcon fontSize="small" sx={{ mr: 0.5 }} /> {title}
      </InfoTitle>
      {actions}
    </Box>
  );
}
